import type { SVGProps } from 'react'
const SvgSyRadar = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M12 14.38a2.38 2.38 0 1 0 0-4.76 2.38 2.38 0 0 0 0 4.76" />
		<path
			d="M20 18.75a.75.75 0 0 1-.6-1.2A9.17 9.17 0 0 0 21.25 12c0-2.02-.64-3.94-1.85-5.55a.75.75 0 0 1 1.2-.9c1.41 1.87 2.15 4.1 2.15 6.45s-.74 4.58-2.15 6.45c-.15.2-.37.3-.6.3m-16 0c-.23 0-.45-.1-.6-.3-1.41-1.87-2.15-4.1-2.15-6.45s.74-4.58 2.15-6.45a.75.75 0 0 1 1.2.9A9.17 9.17 0 0 0 2.75 12c0 2.02.64 3.94 1.85 5.55a.75.75 0 0 1-.6 1.2m12.8-2.4a.75.75 0 0 1-.6-1.2c.69-.91 1.05-2 1.05-3.15s-.36-2.24-1.05-3.15a.75.75 0 0 1 1.2-.9A6.73 6.73 0 0 1 18.75 12c0 1.47-.47 2.88-1.35 4.05-.15.2-.37.3-.6.3m-9.6 0c-.23 0-.45-.1-.6-.3A6.73 6.73 0 0 1 5.25 12c0-1.47.47-2.88 1.35-4.05a.75.75 0 0 1 1.2.9c-.69.91-1.05 2-1.05 3.15s.36 2.24 1.05 3.15a.75.75 0 0 1-.6 1.2"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyRadar
